<template>
  <b-container
    class="admin-home-view-container"
    fluid
  >
    <MissionInfo
      v-if="stateShowed"
      :hideStatement="hideStatement"
      :missionFocus="missionFocus"
    />
    <h4 class="admin-home-title">審核中任務：</h4>
    <MissionTable
      v-if="filterMissionByAdmin"
      :items="systemMission"
      :productMethod="editMission"
    />
    <section
      class="no-mission"
      v-else
    >無處理中任務...</section>

    <h4 class="admin-home-title">已發布消息：</h4>
    <NewsTable :items="news" />

    <h4 class="admin-home-title">所有產品：</h4>
    <article v-if="products.length">
      <CardUi
        v-for="(product, index) in products"
        :key="index"
        :product="product"
      />
    </article>
    <article v-else>
      <b-spinner label="Spinning"></b-spinner>
    </article>
  </b-container>
</template>

<script>
  import { mapState, mapGetters } from "vuex";
  import CardUi from "@/components/CardUi";
  import MissionTable from "@/components/MissionTable";
  import MissionInfo from "@/components/MissionInfo";
  import NewsTable from "@/components/NewsTable";

  export default {
    data() {
      return {
        missionFocus: null,
        stateShowed: false,
      };
    },
    computed: {
      ...mapState("backend", [
        "AdminID",
        "AdminName",
        "Authority",
        "products",
        "news",
      ]),
      ...mapState("login", ["account", "user"]),
      ...mapGetters("backend", ["filterMissionByAdmin"]),

      systemMission: function () {
        return this.filterMissionByAdmin
          .map((doc) => {
            const missionTitle = doc.system === "News" ? doc.Statement.news_CH : doc.Statement.name_CH;
            return { ...doc, missionTitle };
          });
      },
    },
    methods: {
      editMission: function (mission) {
        this.stateShowed = true;
        this.missionFocus = mission;
      },
      hideStatement: function () {
        this.stateShowed = false;
      },
    },
    components: {
      CardUi,
      MissionTable,
      MissionInfo,
      NewsTable,
    },
  };
</script>
